module.exports = __webpack_public_path__ + "static/media/mileage_2_1.ed911c26.png";